import { gql } from '@apollo/client';

import ORGANIZATION_FRAGMENT from '../fragments/organization';

const SEARCH_ORGANIZATIONS_QUERY = gql`
  query searchOrganizations(
    $searchText: String!
    $organizationType: [OrganizationType!]
    $organizationIds: [Int!]
    $limit: Int
  ) {
    organizations(
      where: { name_contains: $searchText, type: $organizationType, id: $organizationIds }
      orderBy: { field: [NAME, ID], direction: [ASC, DESC] }
      paging: { limit: $limit }
    ) {
      ...BaseOrganization
    }
  }
  ${ORGANIZATION_FRAGMENT}
`;

export default SEARCH_ORGANIZATIONS_QUERY;
